/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import classNames from 'classnames'
import { noop } from 'lodash'
import React, { useCallback } from 'react'

import { IconClose } from 'src/assets/icons'

import { Popup as MapGlPopup } from 'react-map-gl/mapbox'
import { v4 } from 'uuid'
import { Icon, palette } from '@centivo/react-components'
import styled from 'styled-components'

import { PinData } from './types'

interface Props extends PinData {
  shouldShow?: boolean
  onClosePopup?(id: string, forceState?: 'close' | 'open'): void
}

const SliceTitleContainer = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
`

const SliceContainer = styled.div`
  display: flex;
  align-items: center;

  &:nth-child(3) {
    margin-top: -0.35rem;
    margin-bottom: 0.5rem;
  }
`

const SliceText = styled.p`
  color: ${palette.brand.darkGray} !important;
  font-weight: 400;
`

const SliceTitle = styled.h6`
  color: ${palette.brand.darkGray} !important;
  margin-bottom: 8px;
  &:first-of-type {
    font-weight: 600;
    font-size: 14px;
  }
`

const offset = [-4, -24] as [number, number]

export const PopupSlice: React.FC<Props> = React.memo(
  ({
    latitude = 0,
    longitude = 0,
    onClosePopup = noop,
    title,
    text,
    shouldShow,
    id,
  }) => {
    const onClose = useCallback(
      () => onClosePopup(id, 'close'),
      [onClosePopup, id]
    )

    const isPhoneData = (data: string) => {
      return data && data.match(/^(\(\d{3}\) ?|\d{3}-|\d{3} ?)\d{3}-?\d{4}/)
    }

    return (
      <MapGlPopup
        latitude={latitude}
        longitude={longitude}
        anchor="bottom"
        offset={offset}
        onClose={onClose}
        closeButton={false}
        className={classNames({
          hidden: !shouldShow,
        })}
      >
        <SliceTitleContainer aria-hidden tabIndex={-1}>
          {title && (
            <SliceTitle aria-hidden tabIndex={-1}>
              {title}
            </SliceTitle>
          )}
          <div onClick={onClose} style={{ cursor: 'pointer' }}>
            <IconClose width="1rem" height="1rem" color={palette.brand.brown} />
          </div>
        </SliceTitleContainer>
        {text &&
          text.map(phrase => {
            return (
              <SliceContainer aria-hidden tabIndex={-1}>
                {isPhoneData(phrase) && (
                  <Icon
                    icon="slice-Phone"
                    color={palette.brand.brown}
                    size="1rem"
                    style={{ marginRight: '4px' }}
                    aria-hidden
                  />
                )}
                <SliceText key={v4()} aria-hidden tabIndex={-1}>
                  {phrase}
                </SliceText>
              </SliceContainer>
            )
          })}
      </MapGlPopup>
    )
  }
)
